import customerAccountQuery from './queries/CustomerAccount.graphql';

export { customerAccountQuery };
